import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { EmptySorting, FilterTabType } from '../../../imageFilters.model';
import { FilterHeader } from '../FilterHeader';
import { ImageFiltersFormProps } from '../ImageFiltersForm';

export const SortingHeader = observer((props: ImageFiltersFormProps): ReactElement => {
  const handleClear = (): void => {
    props.onSetSorting([{ ...EmptySorting }]);
  };

  const isSelected = props.activeFilterType === FilterTabType.Sorting;
  const count = props.imageFilters.sorting.filter((x) => x.by !== undefined).length;

  return (
    <FilterHeader
      filterType={FilterTabType.Sorting}
      isSelected={isSelected}
      labelKey='sorting'
      count={count}
      showClear={count > 0}
      onClear={handleClear}
      onSelect={props.onFilterTabSelect}
    />
  );
});
